import React from 'react';
import PropTypes from 'prop-types';

import FullScreenLayout from './FullScreenLayout';
import ClassroomLayoutContainer from './ClassroomLayout.container';
import FixedLayout from './FixedLayout';

const VARIANTS = {
  FIXED: 'FIXED',
  FULL: 'FULL',
};
const ClassroomLayoutView = ({
  variant,
  renderHeader,
  renderFooter,
  renderChildren,
  renderSidebar,
  ...props
}) => {
  switch (variant) {
    case VARIANTS.FIXED:
      return (
        <FixedLayout
          renderHeader={renderHeader}
          renderFooter={renderFooter}
          renderChildren={renderChildren}
          renderSidebar={renderSidebar}
          {...props}
        />
      );
    case VARIANTS.FULL:
    default:
      return (
        <ClassroomLayoutContainer>
          {({ active, setLayoutActive, setLayoutInactive, toggleLayoutActive }) => {
            return (
              <FullScreenLayout
                active={active}
                onMouseOver={(e) => {
                  setLayoutActive();
                  e.stopPropagation();
                }}
                renderHeader={() => renderHeader({ active, toggleLayoutActive, setLayoutActive })}
                renderFooter={() => renderFooter({ active, toggleLayoutActive, setLayoutActive })}
                renderChildren={() =>
                  renderChildren({ active, toggleLayoutActive, setLayoutActive })
                }
              />
            );
          }}
        </ClassroomLayoutContainer>
      );
  }
};

ClassroomLayoutView.VARIANTS = VARIANTS;

ClassroomLayoutView.propTypes = {
  renderHeader: PropTypes.func,
  renderFooter: PropTypes.func,
  renderChildren: PropTypes.func,
  renderSidebar: PropTypes.func,
};
ClassroomLayoutView.defaultProps = {
  renderHeader: () => null,
  renderFooter: () => null,
  renderChildren: () => null,
  renderSidebar: () => null,
};

export default ClassroomLayoutView;
